document.addEventListener('DOMContentLoaded', function () {
  const lazyImages = document.querySelectorAll('img[data-src]');

  lazyImages.forEach((img) => {
    const src = img.getAttribute('data-src');
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }
  });

  const showCard = (dialog) => {
    if (dialog.showModal) {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.body.classList.add('overflow-hidden');
  };

  const closeCard = (dialog) => {
    if (dialog.close) {
      dialog.classList.add('closing');
      dialog.addEventListener(
        'animationend',
        () => {
          dialog.close();
          dialog.classList.remove('closing');
        },
        { once: true },
      );
    } else {
      dialog.classList.add('closing');
      dialog.addEventListener(
        'animationend',
        () => {
          dialog.removeAttribute('open');
          dialog.classList.remove('closing');
        },
        { once: true },
      );
    }
    document.body.classList.remove('overflow-hidden');
  };

  const initializeModals = (sectionClass) => {
    const section = document.querySelector(sectionClass);
    if (!section) return;

    const cardShowButtons = section.querySelectorAll('[data-card-show]');
    const cardCloseButtons = section.querySelectorAll('[data-card-close]');

    cardShowButtons.forEach((button, index) => {
      button.addEventListener('click', function () {
        const dialog = section.querySelector(`#dialog-card-${index + 1}`);
        if (dialog) {
          showCard(dialog);
        }
      });
    });

    cardCloseButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const dialog = button.closest('dialog');
        if (dialog) {
          closeCard(dialog);
        }
      });
    });

    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        const openDialog = section.querySelector('dialog[open]');
        if (openDialog) {
          closeCard(openDialog);
        }
      }
    });

    const dialogs = section.querySelectorAll('dialog[data-card]');
    dialogs.forEach((dialog) => {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          closeCard(dialog);
        }
      });
    });
  };

  initializeModals('.section1');
  initializeModals('.cards');

  const newsletterButton = document.querySelector('[data-newsletter-modal]');
  const newsletterDialog = document.getElementById('newsletter-dialog');

  if (newsletterButton && newsletterDialog) {
    newsletterButton.addEventListener('click', function (event) {
      event.preventDefault();
      showCard(newsletterDialog);
    });

    const closeButton = newsletterDialog.querySelector('[data-card-close]');
    closeButton.addEventListener('click', function () {
      closeCard(newsletterDialog);
    });

    newsletterDialog.addEventListener('click', function (event) {
      if (event.target === newsletterDialog) {
        closeCard(newsletterDialog);
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && newsletterDialog.hasAttribute('open')) {
        closeCard(newsletterDialog);
      }
    });
  }

  const cartButton = document.querySelectorAll('[data-cart-show]');
  const cartModal = document.querySelector('[data-cart]');

  if (cartButton && cartModal) {
    cartButton.forEach((button, index) => {
      button.addEventListener('click', function () {
        showCard(cartModal);
      });
    });

    const cartClose = cartModal.querySelector('[data-cart-close]');
    cartClose.addEventListener('click', function () {
      closeCard(cartModal);
    });

    cartModal.addEventListener('click', function (event) {
      if (event.target === cartModal) {
        closeCard(cartModal);
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && cartModal.hasAttribute('open')) {
        closeCard(cartModal);
      }
    });
  }
});
